"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caprese-michelangelo": {
    "b63911bb": [{
      "hkey": "9e2b08f0",
      "slug": "san-cristoforo-caroni-manzi",
      "name": "San Cristoforo-Caroni-Manzi",
      "primary": true,
      "skipSearch": false
    }],
    "san-cristoforo-caroni": [{
      "hkey": "9e2b08f0",
      "slug": "san-cristoforo-caroni-manzi",
      "name": "San Cristoforo-Caroni-Manzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;